import type { LeadOrigin, LeadStage, LeadFileKind } from '@agencia/shared';

export interface LeadCard {
  id: string;
  nome: string;
  telefone: string | null;
  etapa: LeadStage;
  origem: LeadOrigin;
  origemDetalhe: string | null;
  originLinkNome: string | null;
  consultor: { id: string; nome: string } | null;
  primeiraMensagem: string | null;
  resumo: string | null;
  valorEstimado: string | null;
  motivoPerda: string | null;
  retornoEm: string | null;
  retornoNota: string | null;
  primeiroContatoEm: string;
  ultimaMensagemEm: string | null;
  arquivos: number;
  digisac: boolean;
  email: string | null;
  iaMotivo: string | null;
}

export interface Capabilities {
  ia: boolean;
  email: boolean;
  mercadoPago: boolean;
  monitorVoos: boolean;
}

export interface LeadDetail extends LeadCard {
  events: Array<{ id: string; tipo: string; descricao: string; por: string | null; createdAt: string }>;
  files: Array<{ id: string; tipo: LeadFileKind; nome: string; mimeType: string; tamanho: number; enviadoPor: string | null; origem: 'DIGISAC' | 'MANUAL'; saleId: string | null; enviadoEmailEm: string | null; createdAt: string }>;
  sales: Array<{ id: string; numero: number | null; dataVenda: string; valorBruto: string; status: string }>;
}

export const ORIGIN_TONE: Record<LeadOrigin, string> = {
  INSTAGRAM: 'pink',
  FACEBOOK: 'blue',
  GOOGLE: 'amber',
  ANUNCIO: 'orange',
  SITE: 'teal',
  INDICACAO: 'purple',
  IMPRESSO: 'gray',
  WHATSAPP: 'green',
  OUTRO: 'gray',
  DESCONHECIDA: 'gray',
};

/** "há 12 min", "há 3 h", "ontem", "12/11" */
export function quando(iso: string | null): string {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.round(diff / 60_000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `há ${h} h`;
  if (h < 48) return 'ontem';
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'America/Bahia' }).format(new Date(iso));
}

export function retornoAtrasado(iso: string | null): 'hoje' | 'atrasado' | null {
  if (!iso) return null;
  const d = new Date(iso);
  const fim = new Date();
  fim.setHours(23, 59, 59, 999);
  if (d < new Date()) return 'atrasado';
  return d <= fim ? 'hoje' : null;
}
